<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="司機" name="driver">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>隊編/呼號: {{ driverInfo.call_number }}</span>
        </el-col>
        <el-col :span="12">
          <span>車號: {{ driverInfo.licence }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>狀態: {{ driverInfo.status }}</span>
        </el-col>
        <el-col :span="12">
          <span>車齡: {{ carYear(driverInfo.car_leave_factory_date) }}年</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>姓名: {{ driverInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>性別: {{ driverInfo.gender }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>廠牌: {{ driverInfo.car_brand }}</span>
        </el-col>
        <el-col :span="12">
          <span>電話(帳號): {{ driverInfo.account }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>聯絡電話1: {{ driverInfo.contact1 }}</span>
        </el-col>
        <el-col :span="12">
          <span>聯絡電話2: {{ driverInfo.contact2 }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>司機備註: {{ driverInfo.note }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>客服備註(乘客看不到): {{ driverInfo.team_company_note }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>服務項目: {{ serviceList }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>軌跡更新時間: {{ driverInfo.updated_at }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span v-if="!istriggerEvent">地址: {{ address }}</span>
          <span v-else>地址: 搜尋地址中...</span>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          size="large"
          type="primary"
          @click="recordPage(driverInfo.id, '單一司機資料')"
        >
          司機資料編輯紀錄
        </el-button>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="排班站" name="schedule">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>排班站名稱: {{ shiftAreaInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>
            容納車輛數:
            {{
              shiftAreaInfo.area_capacity === null
                ? 100
                : shiftAreaInfo.area_capacity
            }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>
            排班時間1: {{ dispatchAreaInfo.dispatch_strategy }}-{{
              shiftAreaInfo.in_line_time1_end
            }}
          </span>
        </el-col>
        <el-col :span="12">
          <span>
            排班時間2: {{ shiftAreaInfo.in_line_time2_start }}-{{
              shiftAreaInfo.in_line_time2_end
            }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>備註: {{ shiftAreaInfo.note }}</span>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="派遣區域" name="dispatch">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣區域名稱: {{ dispatchAreaInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>
            容納車輛車:
            {{
              dispatchAreaInfo.area_capacity === null
                ? 100
                : dispatchAreaInfo.area_capacity
            }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣策略: {{ dispatchAreaInfo.dispatch_strategy }}</span>
        </el-col>
        <el-col :span="12">
          <span>派遣排班站1: {{ dispatchAreaInfo.in_line_name1 }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣排班站2: {{ dispatchAreaInfo.in_line_name2 }}</span>
        </el-col>
        <el-col :span="12">
          <span>備註: {{ dispatchAreaInfo.note }}</span>
        </el-col>
      </el-row>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import dayjs from 'dayjs'
import API from '../../assets/js/libs/API'

export default {
  props: ['driverInfo', 'shiftAreaInfo', 'dispatchAreaInfo'],
  data() {
    return {
      activeName: 'driver',
      istriggerEvent: false,
      address: '',
    }
  },
  methods: {
    _clickItemToSetAddress(driverInfo) {
      if (driverInfo.lng === undefined) return
      if (driverInfo.lat === undefined) return
      this.istriggerEvent = true
      API.get(
        `service/address/near/?points=${driverInfo.lng},${driverInfo.lat}`,
      )
        .then((res) => {
          this.istriggerEvent = false
          this.address = res.result[0]
        })
        .catch((e) => {
          console.error(e)
          this.$msg('連線失敗，再試一次')
          this.istriggerEvent = false
        })
    },
    carYear(year) {
      if (!year) return ''
      const yearDiff = dayjs().format('YYYY') - dayjs(year).format('YYYY')
      return yearDiff > 0 ? `${yearDiff}` : '<1'
    },
    showTable(name, driverInfo) {
      this.activeName = name
      if (name === 'driver') {
        this._clickItemToSetAddress(driverInfo)
      }
    },
    recordPage(id, type) {
      if (id === undefined) return this.$msg('請選擇司機')
      this.$router.push({
        name: 'activityRecord',
        query: { id: id, type: type },
      })
    },
  },
  computed: {
    serviceList() {
      let serviceList = []
      for (let i = 0; i < this.driverInfo.service_list.length; i++) {
        serviceList.push(this.driverInfo.service_list[i].name)
      }
      return serviceList.join(',')
    },
  },
}
</script>
<style scoped>
.black-word {
  color: #101010;
}
span {
  font-size: 16px;
}
.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/driver/DriverMonitorTab.vue